<template>
  <v-bottom-navigation
    class="show"
    fixed
    v-model="value"
    :background-color="color"
    dark
    shift
  >
    <v-btn
      :to="{
        name: 'homestore',
      }"
    >
      <span>خانه</span>
      <v-icon>mdi-home</v-icon>
    </v-btn>

    <v-btn
      :to="{
        name: 'Home',
      }"
    >
      <span>غرفه ها</span>
      <v-icon>mdi-store</v-icon>
    </v-btn>

    <v-btn
      :to="{
        name: 'aroundme',
      }"
    >
      <span>اطراف من</span>
      <v-icon>mdi-google-maps</v-icon>
    </v-btn>

    <!-- <v-btn>
      <span>پروفایل</span>
      <v-icon>mdi-account</v-icon>
    </v-btn> -->
  </v-bottom-navigation>
</template>

<script>
export default {
  data() {
    return { value: 1 };
  },
  computed: {
    color() {
      switch (this.value) {
        case 0:
          return "info";
        case 1:
          return "teal";
        case 2:
          return "indigo";
        default:
          return "blue-grey";
      }
    },
  },
};
</script>

<style scoped>
.show {
  display: flex;
}
@media (min-width: 900px) {
  .show {
    display: none !important;
  }
}
.v-item-group.v-bottom-navigation {
  bottom: -1px;
  display: flex;
  left: 0;
  justify-content: center;
  width: 100%;
  box-shadow: 0 2px 4px -1px rgb(0 0 0 / 20%), 0 4px 5px 0 rgb(0 0 0 / 14%),
    0 1px 10px 0 rgb(0 0 0 / 12%);
}
</style>
